import { render, staticRenderFns } from "./SidebarInvoiceConfiguration.vue?vue&type=template&id=3291d412&"
import script from "./SidebarInvoiceConfiguration.vue?vue&type=script&lang=js&"
export * from "./SidebarInvoiceConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./SidebarInvoiceConfiguration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports